/*
  Bảng bậc "Buy more, save more" trên trang sản phẩm.

  BA THỨ PHẢI TỰ DÒ LẠI MỖI LẦN, KHÔNG ĐƯỢC NHỚ SẴN

  1. Ô số lượng bị Customily BÊ ĐI. Hàm `placeQuantity()` của app bốc nguyên thẻ
     <quantity-selector-component> sang khung nút của nó (bắt được stack
     24/08/2026). Node cũ giữ trong biến là node đã bị ngắt khỏi cây — đọc ra
     giá trị cũ mãi mãi. Nên mọi lần cần đều querySelector lại từ document.

  2. Đổi size thì Horizon dựng lại cả section (morph), thẻ này bị thay mới. Vì
     vậy connectedCallback phải làm được việc trọn vẹn, không dựa vào state cũ.

  3. Người bán đổi bậc trong metafield mà không đụng code — số bậc, phần trăm,
     bậc nào gắn nhãn đều đọc từ data-*. Không có con số nào viết cứng ở đây.

  CHỌN VARIANT NÀO: đọc `input[name="id"]` trong form mua hàng. Đây là nguồn duy
  nhất đúng — nó là thứ thực sự được POST lên /cart/add, còn nút chọn size chỉ
  là giao diện. Theme không bắn event riêng cho việc đổi variant (events.js chỉ
  có quantity-selector:update), nên dò bằng vòng lặp nhẹ 400ms; dừng khi tab ẩn.

  CÁCH TÍNH TIỀN — ĐO TỪ GIỎ THẬT, KHÔNG SUY DIỄN

  Discount đang chạy là "cái thứ hai trong mỗi cặp giảm 50%". Đo trên giỏ thật
  24/08/2026 với size 5.5 inch (19.99):

      1 cái → 19.99      2 cái → 29.99      3 cái → 49.98
      4 cái → 59.98      5 cái → 79.97      6 cái → 89.97

  Khớp đúng công thức: tiền bớt mỗi cặp = đơn giá − làm-tròn(đơn giá × 50%)
  = 1999 − 1000 = 999. Tổng = đơn giá × số lượng − số cặp × 999.

  Bẫy làm tròn: 19.99 giảm nửa ra 9.995. Lấy 1000 rồi trừ ngược ra 999 mới khớp
  giỏ; ghi thẳng "giảm 9.99" hay "giảm 10.00" đều lệch một xu ở vài mức.
*/
(function () {
  const POLL_MS = 400;

  const money = (cents) => '$' + ((Number(cents) || 0) / 100).toFixed(2);

  class VolumeOfferComponent extends HTMLElement {
    connectedCallback() {
      this.secondPercent = parseInt(this.dataset.secondPercent, 10) || 0;
      this.highlightQty = parseInt(this.dataset.highlightQty, 10) || 0;
      this.tiers = this.normalizeTiers(this.parse(this.dataset.tiers, []));
      this.prices = this.parse(this.dataset.prices, {});

      if (!this.tiers.length) return;
      if (!this.percentByQty && !this.secondPercent) return;

      this.tiersEl = this.querySelector('[ref="tiers"]');
      this.signature = null;

      /* Variant mình ĐOÁN lúc khách vừa bấm size, dùng tạm cho tới khi
         `input[name="id"]` thật sự đổi. Xem `onVariantPick()`. */
      this.pendingVariantId = null;
      this.pendingBaseId = null;
      this.pendingAt = 0;

      this.sync = this.sync.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onVariantPick = this.onVariantPick.bind(this);
      this.tiersEl.addEventListener('click', this.onClick);

      /*
        NGHE Ở TẦNG CAPTURE, KHÔNG ĐỢI THEME.

        Đổi size thì Horizon fetch Section Rendering API rồi mới morph — đo trên
        live 25/08/2026 là 580ms, gần như toàn bộ là chờ mạng. Trong 580ms đó
        `input[name="id"]` vẫn còn giá trị cũ nên bảng bậc hiện giá của size cũ.

        Nhưng mỗi ô radio đã mang sẵn `data-variant-id` (variant-picker.js dùng
        chính nó để dựng URL fetch), mà `data-prices` thì đã nhúng giá của TẤT
        CẢ variant từ lúc render trang. Tức là mọi thứ cần để vẽ đúng đều có sẵn
        trong trang, không việc gì phải đợi mạng.

        Capture (`true`) để chạy trước `variant-picker` — nó nghe `change` bubble
        lên chính nó (`variant-picker.js:48`).
      */
      document.addEventListener('change', this.onVariantPick, true);

      /* Bắn ngay khi số lượng đổi, khỏi đợi hết một nhịp 400ms — bấm +/- mà bảng
         bậc sáng chậm một nhịp thì trông như hỏng. */
      document.addEventListener('quantity-selector:update', this.sync);
      document.addEventListener('visibilitychange', this.sync);

      /*
        MORPH XOÁ DÒNG GIÁ CỦA MÌNH — PHẢI DỰNG LẠI TRƯỚC KHI TRÌNH DUYỆT VẼ.

        Đổi size thì Horizon gọi `morphSection()`, mà `updateChildren()` trong
        morph.js có nhánh "There is no new child, remove old": dòng
        `.volume-offer__price-line` mình chèn không có trong HTML server trả về
        nên bị xoá, và `class` của khối giá bị ghi đè nên mất luôn
        `has-volume-total`. Đo 25/08/2026: khối giá tụt về một dòng đơn giá,
        phần dưới nhảy lên 169px, tới nhịp poll kế tiếp mới nhảy về.

        MutationObserver chữa được vì callback của nó chạy ở microtask — xong
        trong cùng một khung hình với morph, nên mắt không kịp thấy trạng thái
        giữa chừng. Vòng lặp 400ms giữ lại làm lưới an toàn cho những đường
        Customily đụng vào DOM mà không sinh mutation ở đây.

        KHÔNG SỢ LẶP VÔ HẠN: ghi của mình cũng sinh mutation, nhưng `sync()` giờ
        là idempotent — gọi lại mà trạng thái đã đúng thì không đụng DOM, không
        sinh mutation mới, vòng tự tắt. Đừng bỏ cái mốc `data-vo-sig` ở
        `updatePriceLine()`, bỏ là thành vòng lặp thật.
      */
      const scope = this.closest('[id^="shopify-section"]') || document.body;
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'value'],
      });

      this.timer = setInterval(this.sync, POLL_MS);
      this.sync();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('quantity-selector:update', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
      document.removeEventListener('change', this.onVariantPick, true);

      /*
        Đã có thẻ khác thế chỗ (morph dựng lại section) thì để yên dòng giá của
        nó. Bản cũ xoá theo selector toàn trang nên thẻ mới vừa vẽ xong là bị
        thẻ cũ đang tháo xuống xoá mất.
      */
      if (document.querySelector('volume-offer-component')) return;

      /*
        Gỡ `has-volume-total` chứ không chỉ xoá dòng giá. Class này GIẤU con số
        gốc của theme — xoá dòng mà để lại class là khối giá trống trơn, khách
        không thấy giá nào hết.
      */
      document.querySelectorAll('.volume-offer__price-line').forEach((el) => el.remove());
      document.querySelectorAll('.has-volume-total').forEach((el) => el.classList.remove('has-volume-total'));
    }

    parse(raw, fallback) {
      try {
        return JSON.parse(raw || '');
      } catch (e) {
        return fallback;
      }
    }

    /* Ô số lượng đang thực sự nằm trên trang — tra lại mỗi lần vì Customily bê đi. */
    quantityInput() {
      const el = document.querySelector('quantity-selector-component input[type="number"]');
      return el && el.isConnected ? el : null;
    }

    variantId() {
      const el = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const live = el ? String(el.value || '') : '';

      if (!this.pendingVariantId) return live;

      /*
        BA ĐƯỜNG BỎ CÁI ĐOÁN — thiếu đường nào cũng có ngày kẹt giá sai.

        1. Server chốt đúng như mình đoán → xong việc, trả về giá trị thật.
        2. Server chốt một variant KHÁC (hết hàng, combined listing, khách bấm
           tiếp size thứ ba lúc fetch còn bay) → tin server, vứt cái đoán.
        3. Quá 5 giây mà `input` vẫn không nhúc nhích → fetch hỏng hoặc bị huỷ.
           Không có mốc này thì một request lỗi là bảng bậc kẹt ở size đoán mãi
           mãi, mà giá hiện ra lại không phải giá sẽ bị tính tiền.
      */
      if (live === this.pendingVariantId) {
        this.pendingVariantId = null;
        this.restoreThemePrice();
      } else if (live !== this.pendingBaseId || Date.now() - this.pendingAt > 5000) {
        this.pendingVariantId = null;
        this.restoreThemePrice();
      } else {
        return this.pendingVariantId;
      }

      return live;
    }

    /*
      Khách vừa bấm một ô size — vẽ lại ngay bằng giá đã nhúng sẵn.

      Chỉ nhận khi `data-prices` thật sự có variant đó. Không có thì im lặng bỏ
      qua, để đường cũ (đợi morph) lo — thà chậm còn hơn hiện một con số bịa.
    */
    onVariantPick(event) {
      const el = event.target;
      if (!(el instanceof HTMLElement)) return;

      const id = el.dataset ? el.dataset.variantId : null;
      if (!id || !this.prices[id]) return;

      const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      this.pendingBaseId = input ? String(input.value || '') : '';
      if (String(id) === this.pendingBaseId) return;

      this.pendingVariantId = String(id);
      this.pendingAt = Date.now();
      this.signature = null;
      this.sync();
    }

    /*
      HAI KIỂU METAFIELD, DỰNG CHUNG MỘT MẢNG SỐ LƯỢNG.

        cũ:  "tiers": [1, 2, 4, 6]  kèm  "second_item_percent": 50
        mới: "tiers": [{"qty": 1, "percent": 0}, {"qty": 2, "percent": 25}, …]

      Kiểu cũ ứng với discount Buy X get Y lặp theo cặp — mọi bậc chẵn giảm
      như nhau. Kiểu mới ứng với mỗi bậc một automatic discount "Amount off
      products" riêng, bậc càng cao phần trăm càng sâu.

      Chỉ cần MỘT bậc khai `percent` là cả bảng chuyển sang tra bậc; bậc nào
      thiếu `percent` thì coi như 0%. Trả về mảng SỐ, không phải mảng object,
      để `buildTier()` không phải biết metafield viết theo kiểu nào.
    */
    normalizeTiers(raw) {
      this.percentByQty = null;
      this.amountByQty = null;
      if (!Array.isArray(raw)) return [];

      const qtys = [];

      raw.forEach((tier) => {
        const isObject = tier !== null && typeof tier === 'object';
        const qty = parseInt(isObject ? tier.qty : tier, 10);
        if (!qty || qty < 1) return;

        qtys.push(qty);

        if (isObject && tier.percent != null) {
          if (!this.percentByQty) this.percentByQty = {};
          this.percentByQty[qty] = parseFloat(tier.percent) || 0;
        }

        // `amount_off` (cent): giảm thẳng một số tiền, 1 lần mỗi đơn — ứng với
        // discount "Fixed amount" + "Only apply once per order". Dùng khi cần
        // tổng ra số lẻ như $27.95 (giảm % trừ từng cái nên tổng luôn chẵn).
        if (isObject && tier.amount_off != null) {
          if (!this.percentByQty) this.percentByQty = {};
          if (!this.amountByQty) this.amountByQty = {};
          this.amountByQty[qty] = parseInt(tier.amount_off, 10) || 0;
        }
      });

      return qtys;
    }

    /* Tổng tiền cho `qty` cái, theo đúng cách giỏ hàng tính (xem đầu file). */
    totalFor(unit, qty) {
      if (this.percentByQty) return this.totalByTier(unit, qty);

      const secondPrice = Math.round((unit * (100 - this.secondPercent)) / 100);
      const perPair = unit - secondPrice;
      return unit * qty - Math.floor(qty / 2) * perPair;
    }

    /*
      KIỂU BẬC: LẤY BẬC SÂU NHẤT MÀ `qty` VỚI TỚI.

      Duyệt hết thay vì lấy bậc cuối cùng đủ điều kiện: khi nhiều automatic
      discount cùng ăn mà không combine được, Shopify chọn cái LỢI NHẤT CHO
      KHÁCH. Lấy max ở đây thì dù metafield có gõ lộn thứ tự, hay bậc 6 lỡ
      đặt nông hơn bậc 4, màn hình vẫn khớp giỏ hàng.

      TIỀN BỚT TÍNH THEO TỪNG CÁI, LÀM TRÒN XUỐNG, rồi mới nhân số lượng.

      Đo trên giỏ thật 17/09/2026 (giá $18.99, thang 7/10/15/20/25/30/35%), cả
      10 mức số lượng đều khớp công thức này:
        18.99 × 7%  = 1.3293 → bớt 1.32/cái → 2 cái = 35.34 (giỏ: 35.34)
        18.99 × 15% = 2.8485 → bớt 2.84/cái → 4 cái = 64.60 (giỏ: 64.60)
      Bản cũ làm tròn một lần trên cả dòng (37.98 − 2.66 = 35.32), nên trang
      hiện RẺ HƠN checkout 1 xu mỗi cái ở mọi bậc — hứa giá không có thật.
      Couple $15.99 bớt 35% cũng khớp: 5.5965 → 5.59 → $10.40/cái.
    */
    totalByTier(unit, qty) {
      let percent = 0;

      Object.keys(this.percentByQty).forEach((key) => {
        if (qty >= parseInt(key, 10) && this.percentByQty[key] > percent) {
          percent = this.percentByQty[key];
        }
      });

      const offEach = Math.floor((unit * percent) / 100);
      let off = offEach * qty;

      // Bậc giảm thẳng: Shopify lấy mức lợi nhất cho khách, ở đây cũng vậy.
      if (this.amountByQty) {
        Object.keys(this.amountByQty).forEach((key) => {
          if (qty >= parseInt(key, 10)) {
            off = Math.max(off, Math.min(this.amountByQty[key], unit * qty));
          }
        });
      }

      return unit * qty - off;
    }

    sync() {
      if (document.hidden) return;

      const variantId = this.variantId();
      const unit = parseInt(this.prices[variantId], 10) || 0;
      const input = this.quantityInput();
      const qty = input ? parseInt(input.value, 10) || 0 : 0;

      if (!unit) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      const signature = variantId + '|' + qty;

      /*
        Lưới bậc chỉ vẽ lại khi có gì thật sự đổi. Vòng lặp 400ms mà lần nào
        cũng ghi DOM thì trình đọc màn hình đọc lại liên tục, và mất luôn vùng
        chọn chữ.

        `!this.tiersEl.children.length` là cái chốt thứ hai, cho trường hợp
        morph dọn sạch lưới mà variant lẫn số lượng đều không đổi — lúc đó
        signature giống hệt, thiếu chốt này thì lưới trống vĩnh viễn.
      */
      if (signature !== this.signature || !this.tiersEl.children.length) {
        this.signature = signature;
        this.applyAccent();

        this.tiersEl.innerHTML = '';
        this.tiers.forEach((tierQty) => {
          this.tiersEl.appendChild(this.buildTier(unit, tierQty, qty));
        });
      }

      /* Lúc đang đoán size thì vá luôn con số gốc của theme, cho trường hợp
         mua 1 cái — khi đó dòng giá của mình không hiện, không vá là khách
         nhìn giá size cũ suốt 580ms. */
      if (this.pendingVariantId) this.paintThemePrice(unit);

      /* Dòng giá thì gọi mỗi nhịp — nó tự biết khi nào đã đúng và không ghi gì. */
      this.updatePriceLine(unit, qty, signature);
    }

    /*
      Màu nhấn mượn ĐÚNG màu của giá, không viết cứng.

      Màu giá của Horizon đến từ bảng màu trong theme editor, không có biến CSS
      cố định nào để mượn — nên đọc lúc chạy. Tách thành ba số `r g b` chứ không
      ném nguyên chuỗi `rgb(...)`: CSS còn cần pha loãng nó cho nền thẻ đang
      chọn (`/ 0.045`) và cho bóng đổ, mà chuỗi `rgb()` hoàn chỉnh thì không
      chồng alpha lên được.

      Không đọc ra thì thôi — CSS đã có sẵn giá trị dự phòng ở mọi chỗ dùng.

      ĐỌC Ở <product-price>, KHÔNG ĐỌC Ở THẺ [ref="priceContainer"] ĐẦU TIÊN.

      Trong section mua hàng có HAI khối giá, và thanh dính đáy đứng TRƯỚC khối
      giá chính trong DOM — nên `querySelector` cũ luôn vớ phải thanh dính.

      Thanh dính lại đổi màu theo tình trạng sale, vì `theme-tweaks.css` có luật
        .sticky-add-to-cart__price .price-item__group.price { color: … #000 }
      mà class `price-item__group` CHỈ xuất hiện khi sản phẩm có giá gạch ngang.
      Hệ quả đo được 25/08/2026: Buck & Doe (không sale) ra đỏ #c0392b, còn bản
      Deer copy (sale $24.99 → $15.99) ra ĐEN — hai trang cùng code mà khác màu.

      Khối `<product-price>` không dính luật đó: `product-tweaks.css` đặt
      `product-price .price { color: #c0392b }` cho cả hai trường hợp. Đọc ở đây
      thì màu nhấn bám đúng con số giá to mà khách đang nhìn.
    */
    applyAccent() {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      const scope = (form && form.closest('[id^="shopify-section"]')) || document;
      const el =
        scope.querySelector('product-price .price') || scope.querySelector('[ref="priceContainer"] .price');
      if (!el) return;

      const parts = getComputedStyle(el).color.match(/\d+/g);
      if (parts && parts.length >= 3) {
        this.style.setProperty('--vo-accent-rgb', parts.slice(0, 3).join(' '));
      }
    }

    buildTier(unit, tierQty, currentQty) {
      /*
        THẺ BẬC = HAI DÒNG, ĐƠN GIÁ, HẾT.

        Dựng theo đúng thẻ của wanderprints (đo trên
        /products/…-personalized-handheld-flag-tg458cla3392 ngày 25/08/2026):
        dòng trên số lượng in hoa đậm, dòng dưới đơn giá kèm hậu tố "/pc" nhạt
        hơn. Không tổng tiền, không "Save $X", không nhãn "Best value" — bên đó
        không có cái nào trong ba thứ đó trên thẻ.

        Lý do bỏ tổng khỏi thẻ: `updatePriceLine()` đã bày đúng tổng đó ở khối
        giá chính ngay phía trên, nên để trên thẻ nữa là đọc hai lần cùng một
        con số. Bên wander cũng chia đúng như vậy — giá trên là tổng của gói,
        thẻ chỉ trả lời "mỗi cái còn bao nhiêu".

        BIẾT TRƯỚC MÀ ĐỪNG SỬA (chỉ với KIỂU CẶP): các bậc CHẴN hiện y hệt nhau.

        Discount của mình tính theo CẶP nên đơn giá sau giảm của 2, 4, 6 cái
        bằng nhau — với $19.99 thì cả ba đều ra $15.00/pc. Wander không bị vậy
        vì mỗi bậc bên đó là một variant có giá riêng, bậc càng cao đơn giá càng
        rẻ thật. Muốn thang giá dốc xuống như họ thì phải đổi discount bên
        Shopify sang bậc-theo-số-lượng; bịa số khác nhau ở đây là hiện sai với
        tiền thật ở checkout.

        Bẫy làm tròn: 2999 / 2 = 1499.5, làm tròn LÊN thành 1500 ($15.00) là cố
        ý — đơn giá hiện ra nhân với số lượng luôn ≥ tiền thật, không bao giờ
        hứa rẻ hơn giỏ hàng.
      */
      const perUnit = Math.round(this.totalFor(unit, tierQty) / tierQty);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'volume-offer__tier';
      btn.dataset.qty = String(tierQty);
      /* Bậc nào đang khớp số lượng thì sáng. Dùng aria-pressed thay vì class
         riêng: trình đọc màn hình hiểu luôn, khỏi thêm nhãn ẩn. */
      btn.setAttribute('aria-pressed', currentQty === tierQty ? 'true' : 'false');

      const add = (cls, text) => {
        const el = document.createElement('span');
        el.className = cls;
        el.textContent = text;
        btn.appendChild(el);
      };

      /*
        Nhãn "Most Chosen" — chỗ DUY NHẤT mình cố tình khác wander.

        Bậc nào được gắn nhãn đọc từ `highlight_qty` trong metafield
        `custom.volume_offer`, không viết cứng ở đây. Người bán đổi sang bậc
        khác (hoặc bỏ hẳn bằng cách để 0) là ăn ngay, khỏi đụng code.

        Nhãn đè lên viền trên và canh giữa thẻ, nên thẻ phải `position:
        relative` và lưới phải chừa khoảng trống phía trên — xem CSS.
      */
      if (this.highlightQty === tierQty) add('volume-offer__tier__flag', '\u2713 Most Chosen');

      /* "1 PC" / "2 PCS" — đúng chữ wander dùng, khách POD Mỹ quen mắt. */
      add('volume-offer__tier__qty', tierQty === 1 ? '1 PC' : tierQty + ' PCS');
      add('volume-offer__tier__unit', money(perUnit) + '/pc');

      return btn;
    }

    /*
      Khối giá NÀO được chèn.

      Trang có tới 11 thẻ `[ref="priceContainer"]` (đo 24/08/2026): giá chính,
      thanh mua dính, và giá của từng thẻ sản phẩm gợi ý bên dưới. Lấy đại cái
      đầu tiên là chèn nhầm vào thanh dính hoặc vào thẻ sản phẩm khác.

      Lọc theo section của form mua hàng, rồi bỏ những cái nằm trong thẻ sản
      phẩm — còn đúng hai chỗ cần: giá chính và thanh mua dính.
    */
    priceContainers() {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      const scope = (form && form.closest('[id^="shopify-section"]')) || document;

      return [].slice
        .call(scope.querySelectorAll('[ref="priceContainer"]'))
        .filter((el) => !el.closest('product-card, .product-card, .card-gallery, .resource-list'));
    }

    /*
      Thay HẲN con số ở khối giá chính bằng tổng tiền của số lượng đang chọn.

      Trước đây chỉ chèn thêm một dòng nhỏ bên dưới, giữ nguyên đơn giá — cho
      chặt chẽ, vì đơn giá $19.99 vẫn đúng với người mua 1 cái. Nhưng chọn bậc
      xong mà con số to nhất trang không nhúc nhích thì khách không tin là ưu đãi
      đã ăn. Nên: qty >= 2 thì giấu giá gốc của theme, thay bằng tổng + giá gạch
      + dòng "for N items" để không ai hiểu nhầm đó là đơn giá.

      Giấu bằng class trên chính khối giá, KHÔNG xoá node của theme: đổi size là
      Horizon dựng lại cả khối, xoá node là mất luôn giá gốc khi quay về 1 cái.
    */
    /*
      MỘT DÒNG GIÁ DUY NHẤT.

      Chọn từ 2 cái trở lên thì giấu con số gốc của theme và thay bằng tổng tiền
      của số lượng đang chọn. Trước đây để hai dòng song song (đơn giá + tổng)
      cho chặt chẽ, nhưng nhìn rối và khách không biết đọc dòng nào.

      Ghi kèm "for N items" để không ai hiểu nhầm đó là đơn giá, và giá gạch là
      tổng chưa giảm — hai thứ này giữ cho việc thay số vẫn trung thực.

      Giấu bằng class trên chính khối giá, KHÔNG xoá node của theme: đổi size là
      Horizon dựng lại cả khối, mà quay về 1 cái thì phải có sẵn giá gốc để hiện
      lại.
    */
    /*
      Vá tạm con số của theme trong lúc chờ HTML mới về.

      CHỈ ĐỔI CON SỐ, GIỮ NGUYÊN PHẦN CÒN LẠI. Chuỗi thật trên live là
      "$13.99 USD" — tiền tệ, hậu tố, khoảng trắng đều do locale của store quyết.
      Dựng lại cả chuỗi bằng `money()` là ra "$15.99", mất chữ USD. Nên thay
      đúng cụm số đầu tiên rồi để nguyên vỏ.

      BỎ QUA KHI ĐANG SALE. Có `.compare-at-price` hay `.price-savings` nghĩa là
      khối giá còn giá gạch và số tiền tiết kiệm — mình không biết giá gốc của
      size mới nên vá mỗi giá bán sẽ ra một cặp số đá nhau (giá mới, giá gạch
      cũ). Thà để nó đợi morph.

      Vá xong morph vẫn đè lên bằng số thật của server, nên sai sót (nếu có) chỉ
      sống được đúng một nhịp rồi tự đúng lại.
    */
    paintThemePrice(unit) {
      const next = money(unit).replace('$', '');

      this.priceContainers().forEach((container) => {
        if (container.querySelector('.compare-at-price, .price-savings')) return;

        const el = container.querySelector('.price');
        if (!el) return;

        /* Nhớ nguyên văn ban đầu ngay lần vá đầu tiên. Vá luôn dựng từ bản gốc
           chứ không từ chuỗi đang hiện — vá chồng vá thì đổi size ba lần liên
           tiếp là chuỗi méo dần. */
        if (!('voOrig' in el.dataset)) el.dataset.voOrig = el.textContent;

        const patched = el.dataset.voOrig.replace(/\d[\d.,]*/, next);
        /* So trước khi ghi: ghi thừa là sinh mutation, mà mutation lại gọi
           `sync()` — thành vòng lặp. */
        if (patched !== el.textContent) el.textContent = patched;
      });
    }

    /*
      Trả con số của theme về nguyên trạng khi thôi đoán.

      BẮT BUỘC PHẢI CÓ. Đoán trúng hoặc server chốt khác thì morph đã ghi đè
      bằng số thật rồi, gọi cái này chỉ là dọn cái mốc. Nhưng khi fetch CHẾT —
      mạng rớt, request bị huỷ — thì không có morph nào tới cả, mà `variantId()`
      đã bỏ cái đoán sau 5 giây. Thiếu hàm này là bảng bậc quay về size cũ trong
      khi con số to nhất trang vẫn kẹt ở size khách không chọn: hiện một cái giá
      sẽ không bao giờ được tính tiền.

      `data-vo-orig` tự biến mất sau mỗi lần morph (HTML server không có thuộc
      tính đó nên morph gỡ), nên cái mốc không bao giờ bị cũ.
    */
    restoreThemePrice() {
      document.querySelectorAll('.price[data-vo-orig]').forEach((el) => {
        if (el.textContent !== el.dataset.voOrig) el.textContent = el.dataset.voOrig;
        delete el.dataset.voOrig;
      });
    }

    updatePriceLine(unit, qty, signature) {
      this.priceContainers().forEach((container) => {
        let line = container.querySelector('.volume-offer__price-line');

        if (qty < 2) {
          /* Kiểm trước khi gỡ: `classList.remove` một class không có vẫn tính
             là ghi DOM, mà mỗi lần ghi là một vòng MutationObserver nữa. */
          if (container.classList.contains('has-volume-total')) {
            container.classList.remove('has-volume-total');
          }
          if (line) line.remove();
          return;
        }

        /*
          ĐÃ ĐÚNG THÌ KHÔNG ĐỤNG GÌ.

          Đây là chỗ cắt vòng lặp MutationObserver: `sync()` chạy lại sau mỗi
          mutation, kể cả mutation do chính mình vừa tạo. Không có cái mốc này
          thì lần nào cũng `innerHTML = ''` rồi dựng lại → mutation mới → sync
          mới → treo trình duyệt.
        */
        if (line && line.dataset.voSig === signature && container.classList.contains('has-volume-total')) {
          return;
        }

        container.classList.add('has-volume-total');

        if (!line) {
          line = document.createElement('div');
          line.className = 'volume-offer__price-line';
          container.appendChild(line);
        }

        line.dataset.voSig = signature;

        const total = this.totalFor(unit, qty);
        const saved = unit * qty - total;

        line.innerHTML = '';
        const add = (cls, text) => {
          const el = document.createElement('span');
          el.className = cls;
          el.textContent = text;
          line.appendChild(el);
        };

        /*
          Chép màu và cỡ chữ TỪ CHÍNH thẻ giá gốc, không viết cứng.

          Màu đỏ của giá đến từ cấu hình bảng màu trong theme editor, không có
          biến CSS cố định nào để mượn (đo 24/08/2026: rgb(192,57,43), 20px,
          weight 600). Viết cứng là hôm nào đổi bảng màu sẽ lệch, mà không ai
          nhớ ra chỗ này. Đọc lúc chạy thì luôn khớp.
        */
        const themePrice = container.querySelector('.price');
        const totalEl = document.createElement('span');
        totalEl.className = 'volume-offer__price-line__total';
        totalEl.textContent = money(total);
        if (themePrice) {
          const cs = getComputedStyle(themePrice);
          totalEl.style.color = cs.color;
          totalEl.style.fontSize = cs.fontSize;
          totalEl.style.fontWeight = cs.fontWeight;
          totalEl.style.fontFamily = cs.fontFamily;
        }
        line.appendChild(totalEl);
        if (saved > 0) add('volume-offer__price-line__was', money(unit * qty));
        /*
          "for N items" là chỗ mình KHÁC wander có chủ ý. Bên đó bậc là variant
          tên sẵn "4 PCS" nên nhìn giá là biết của mấy cái; bên mình bậc chỉ đặt
          số lượng, bỏ dòng này là $29.99 trông như đơn giá.
        */
        add('volume-offer__price-line__qty', 'for ' + qty + ' items');
        if (saved > 0) {
          /* Xuống dòng riêng, có cả phần trăm — đúng dòng "You Save 27%
             ($24.00 USD)" của wander. */
          const percent = Math.round((saved / (unit * qty)) * 100);
          add(
            'volume-offer__price-line__save',
            'You Save ' + percent + '% (' + money(saved) + ')'
          );
        }
      });
    }

    /*
      Bấm một bậc chỉ ĐẶT SỐ LƯỢNG, không tự thêm vào giỏ.

      Sản phẩm ở đây đều cá nhân hoá: thêm thẳng vào giỏ là bỏ qua phần khách
      nhập tên, đơn về xưởng không biết in gì (đúng lỗi mà customily-buy-guard
      đang chặn). Đặt số lượng rồi để khách bấm nút mua thật của Customily.
    */
    onClick(event) {
      const btn = event.target.closest('.volume-offer__tier');
      if (!btn) return;

      const qty = parseInt(btn.dataset.qty, 10);
      const input = this.quantityInput();
      if (!qty || !input) return;

      const host = input.closest('quantity-selector-component');
      if (host && typeof host.setValue === 'function') {
        /* Đi qua API của component để nó cập nhật luôn trạng thái nút +/-;
           gán thẳng .value thì nút trừ vẫn nằm im ở trạng thái cũ. */
        host.setValue(String(qty));
        if (typeof host.onQuantityChange === 'function') host.onQuantityChange();
        if (typeof host.updateButtonStates === 'function') host.updateButtonStates();
      } else {
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.signature = null;
      this.sync();
    }
  }

  if (!customElements.get('volume-offer-component')) {
    customElements.define('volume-offer-component', VolumeOfferComponent);
  }
})();
